import { register } from 'timeago.js';
import { ru } from 'timeago.js/esm/lang';

register('ru', ru);
